<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "BankCardType",
        components: {CommonTable},
        data(){
            return{
                searchs:[
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'bankCardType:add',
                    update: 'bankCardType:update',
                    delete: 'bankCardType:delete',
                    deleteBatch: 'bankCardType:deleteBatch'
                },
                url: {
                    get: '/bankCardType/listByCondition',
                    add: '/bankCardType/add',
                    update: '/bankCardType/update',
                    delete: '/bankCardType/delete/',
                    delete_batch: '/bankCardType/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'name',
                    label: '银行名称',
                    show: true,
                    width: '',
                },{
                    field: 'icon',
                    label: '银行图标',
                    show: true,
                    width: '',
                },{
                    field: 'color',
                    label: '颜色',
                    show: true,
                    width: '',
                },{
                    field: 'bgIcon',
                    label: '背景图',
                    show: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加银行类型',
                    updateTitle: '修改银行类型',
                    labelWidth: '105px',
                    model: [{
                        field: 'name',
                        label: '银行名称：',
                        type: 'input',
                        placeholder: '银行名称',
                        rules:[{required: true, message: '请输入银行名称', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'icon',
                        label: '银行图标：',
                        type: 'input',
                        placeholder: '银行图标',
                        rules:[{required: true, message: '请输入银行图标', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'color',
                        label: '颜色：',
                        type: 'input',
                        placeholder: '颜色',
                        rules:[{required: true, message: '请输入颜色', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'bgIcon',
                        label: '背景图：',
                        type: 'input',
                        placeholder: '背景图',
                        rules:[{required: true, message: '请输入背景图', trigger: 'blur'}],
                        add: true,
                        update: true,
                    }],
                },
                operate: [],
            }
        }
    }
</script>

<style scoped>

</style>
